import { render, staticRenderFns } from "./PortalServiciosBanner.vue?vue&type=template&id=e028d04e&scoped=true"
import script from "./PortalServiciosBanner.vue?vue&type=script&lang=ts"
export * from "./PortalServiciosBanner.vue?vue&type=script&lang=ts"
import style0 from "./PortalServiciosBanner.vue?vue&type=style&index=0&id=e028d04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e028d04e",
  null
  
)

export default component.exports